import { RouteEntry } from "../../shared/routes";
import { RedirectToLink } from "./RedirectToLink";

export const linksRoutes: Array<RouteEntry> = [
    { path: '/link/to/:url/', exact: true, component: RedirectToLink, authorize: false, },
];
